import { render, staticRenderFns } from "./ComponentLoading.vue?vue&type=template&id=f53c0660&"
import script from "./ComponentLoading.vue?vue&type=script&lang=js&"
export * from "./ComponentLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports